import React, { useContext, useEffect } from 'react';
import ProductList from "./ProductList";
import GradeSelectionModal from "../grade-selection/GradeSelectionModal";
import InputActivationCode from '../input-activation-code/inputActivationCode';
import PurchaseHeader from "./header/PurchaseHeader"
import Footer from "../footer/Footer";

import styled from 'styled-components';
import { deepCoveDark } from '../../../../app/js/components/loggedout/shared-styles/Colors';
import { breakpoints } from '../../../../app/js/utils/responsive_utilities';
import { SemContext } from "../../context/SemContext";
import { setGrade, getCatalogProducts, setShowGradeSelectionPopup, setShowMorePlans } from "../../actions/actions";

const ProductPurchase = () => {
  let { state, dispatch } = useContext(SemContext);
  const { products = [], coupons = [], settings, showGradeSelectionPopup } = state;
  const variant = localStorage.getItem("sem_variant") || state.variant;
  const campaign_code = localStorage.getItem("campaign_code");
  const coupon = coupons.length ? coupons[0] : null;
  const purchaseSettings = {
    coupon: coupon,
    isSemUser: true,
    stripeKey: settings.stripeKey,
    trailDays: settings.trial_days,
    showZipOnPurchase: settings.showZipOnPurchase,
    showMoneyBack: settings.show_money_back,
    withoutCC : settings.without_cc && JSON.parse(settings.without_cc),
    showPromoPage : settings.show_promo_page && JSON.parse(settings.show_promo_page),
    showPromoInputField : settings.show_promo_input_field,
    campaignCode : campaign_code,
    showPromoPopup : settings.show_promo_popup,
    showRandCurrency : settings.show_rand_currency,
    show_social_nudge: settings.show_social_nudge
  }

  let validTill = coupon && coupon.redeem_by;
  const expiryInDays = parseInt(settings.offer_expiry_in_days);

  if(settings.offer_expiry_in_days && expiryInDays){
    const endofDay = new Date();
    endofDay.setHours((23 * expiryInDays) + (expiryInDays - 1), 59, 59, 999);
    validTill = endofDay;
    try{
      let offerData = JSON.parse(localStorage.getItem("offerData"));
      offerData && localStorage.setItem("offerData",JSON.stringify({...offerData, redeem_by: validTill }))
    }

    catch(err){
      console.log(err);
    }
  }

  const offerInfo = {
    validTill,
    offerText: 'Limited time deal!',
    trailDays: settings.trial_days,
    showMoneyBack: settings.show_money_back,
    planPageHeaderText : settings.plan_page_header_text,
    planPageSubHeaderText : settings.plan_page_sub_header_text,
    planPageLeftHeaderText : settings.plan_page_left_header_text,
    planPageLeftSubHeaderText : settings.plan_page_left_sub_header_text
  }

  const onGradeSelect = async (grade) => {
    if (settings.show_promo_popup !== 'true') { 
      const params = { grade_code: grade, preferred_language: settings.preferred_language, variant: variant, ...(campaign_code && campaign_code != "undefined" && {campaign_code}) };
      const products = await getCatalogProducts(params);
      dispatch(products);
      dispatch(setShowMorePlans(state.settings && state.settings.show_combined_plans));
    }
    dispatch(setGrade(grade));
    dispatch(setShowGradeSelectionPopup(false));
  }

  useEffect(() => {
    if (settings.show_promo_popup !== 'true') {
      dispatch(setShowGradeSelectionPopup(true));
    }
    if (typeof (dataLayer) != "undefined") {
      trackToGtm(dataLayer, 'payment page loaded', 'payment page loaded');
    }
    trackAnalyticsEvent("Visited Plan Purchase Combined Page")

    return ()=>{
      dispatch(setShowMorePlans(false));
    }
  }, [])
  
  return (
    <Wrapper>
      <PurchaseHeader offer={offerInfo} showOfferTime={!["mastercard","miles","redemption","splashlearn_giftup"].includes(campaign_code)}/>
      { settings.show_promo_popup === 'true' && 
        <InputActivationCode />
      }
      { showGradeSelectionPopup && 
        <GradeSelectionModal onCloseHandler={(grade) => onGradeSelect(grade)} />
      }
      <PurchaseWrapper>
        {
          products.length && <ProductList settings={purchaseSettings} products={products} />
        }
        <Footer showPurchaseFooter={true} />
      </PurchaseWrapper>
    </Wrapper>
  )
}

export default ProductPurchase;


const Wrapper = styled.div`
  background: ${deepCoveDark};
  min-height: 100vh;

  @media (min-width: ${breakpoints.lg}px) {
    display: flex;
  }
`;

const PurchaseWrapper = styled.div`
  @media (min-width: ${breakpoints.lg}px) {
    flex-grow: 1;
  }
`;